module.exports = __webpack_public_path__ + "static/media/Violation tooth angulation3.44792b13.png";